<template>
  <div v-show="order.id" class="order-detail-root">
    <div v-if="order.tradeState == 0" class="header-tip">
      请在剩余时间内完成支付，超时订单将自动关闭
    </div>
    <div class="header-container">
      <div class="header-detail">
        <img class="status-img" :src="order_steps.stateUrl" alt />
        <div class="status-detail">
          <div class="status">
            {{ order.tradeState | getOrderTradeStateStr }}
          </div>
          <div class="time">{{ timeStr }}</div>
        </div>
      </div>
      <van-steps
        :active="order_steps.active"
        style="margin: 0 10px"
        active-icon="success"
        active-color="#FF3E3E"
      >
        <van-step v-for="(item, index) in order_steps.steps" :key="index">{{ item.text }}</van-step>
      </van-steps>
      <div class="expressage-wrapper" v-if="order.tradeAddress && order.tradeAddress.logisticsNo">
        <img
          class="icon"
          src="https://img.zai-art.com/zaiart_article/2807d1191c2255aa2cb5c6ef1399a024.png"
          width="18"
          height="18"
          alt
        />
        {{ order.tradeAddress.logisticsCompanyName }}
        <p>{{ order.tradeAddress.logisticsNo }}</p>
        <div class="copy" @click="clickCopy(order.tradeAddress.logisticsNo)">复制</div>
      </div>
    </div>
    <div v-if="order.onSite && !order.onlySite" class="address-type-wrapper">
      <div class="auc-address-type-select-box">
        <div
          :class="
            order.addressType == 0 ? 'auc-address-type-selected' : 'auc-address-type-un-selected'
          "
        >
          快递配送
        </div>
        <div
          :class="
            order.addressType == 1 ? 'auc-address-type-selected' : 'auc-address-type-un-selected'
          "
        >
          到场自取
        </div>
      </div>
    </div>
    <!-- 收货地址 -->
    <div class="section order-address" style="background: #fff" v-if="order.addressType == 0">
      <div style="width: 100%">
        <div class="title" style="margin-bottom: 5px" v-if="order.freightBuyerPay">运费到付</div>
        <div class="content">
          <template v-if="order.tradeAddress">
            <div class="title">{{ order.tradeAddress.name }} {{ order.tradeAddress.phone }}</div>
            <div class="text">
              {{ order.tradeAddress.province }}{{ order.tradeAddress.city
              }}{{ order.tradeAddress.district }}{{ order.tradeAddress.address }}
            </div>
          </template>
        </div>
      </div>
      <div v-if="order.tradeState == 0" class="arrow-icon"></div>
    </div>
    <div v-else-if="order.addressType == 1" class="section order-address" style="background: #fff">
      <div class="content">
        <div class="title">自提地址</div>
        <div class="text">{{ order.siteAddress }}</div>
      </div>
    </div>
    <!-- 订单列 -->
    <div class="section order-info-content">
      <div
        class="item-content-wrapper cell-container"
        v-for="(item, index) in order.tradeItemList"
        :key="index"
      >
        <div class="content-logo-container">
          <!-- <div class='content-logo'> -->
          <!-- <image class='content-logo-img'></image> -->
          <img :src="item.itemImageUrl" width="94" height="94" />
          <!-- </div> -->
        </div>
        <div class="content-column-container">
          <div class="content-title" :style="item.startChPunctuation ? 'text-indent: -.5em;' : ''">
            <p>{{ item.skuName || item.itemName }}</p>
          </div>
          <div class="content-subject">{{ item.skuPropertiesText }}</div>
          <div class="content-price-container">
            <div class="content-price">
              {{ item.itemPrice }}
              <!-- <vip-price showType="2" priceData="{{item.vipPriceData}}" /> -->
            </div>
            <p class="content-count">x{{ item.itemCount }}</p>
          </div>
        </div>
      </div>
      <div class="cell-container">
        <template v-for="item in cellBaseList">
          <div
            :key="item.label"
            :class="{
              cell: true,
              'has-arrow': item.isCoupon,
              'top-divider': item.isPrice,
            }"
            v-if="!item.hide"
          >
            <div class="title">{{ item.label }}</div>
            <p class="content">
              <span v-if="item.before">{{ item.before }}</span>
              <span>{{ item.value }}</span>
              <span v-if="item.after">{{ item.after }}</span>
            </p>
          </div>
        </template>
      </div>

      <div class="cell-container">
        <template v-for="item in cellOrderList">
          <div :key="item.label" :class="{ cell: true, 'bottom-divider': true }" v-if="!item.hide">
            <div class="title">{{ item.label }}</div>
            <div :class="'content ' + item.className">
              <span v-if="item.before">{{ item.before }}</span>
              <span>{{ item.value }}</span>
              <span v-if="item.after">{{ item.after }}</span>
            </div>
          </div>
        </template>
      </div>
    </div>
    <div class="bottom-bar">
      <div class="btn" @click.stop="clickEdit(order)" v-if="false">修改</div>
      <div class="btn" v-if="order.tradeState == 3" @click.stop="clickSend(order)">发货</div>
      <div
        class="btn"
        v-if="
          order.payState === 60 && //支付成功
          order.payAmount > 0 && //商品金额大于0
            (order.tradeType != 21 || !order.tradeTicket || order.tradeTicket.ticketState == 0) // 不是电子票类型 或者没有电子票 或者未核销
        "
        @click.stop="clickRefund(order)"
      >
        退款
      </div>
      <div
        class="btn"
        v-if="order.tradeState == 40 || order.tradeState == 0"
        @click.stop="clickClose(order)"
      >
        关闭订单
      </div>
    </div>
    <refund-dialog
      v-model="refundObj.showDialog"
      :order="refundObj.selectOrder"
      @refund-success="updateOrder"
      :type="35"
    ></refund-dialog>
    <send-dialog
      v-model="sendObj.showDialog"
      :order="sendObj.selectOrder"
      @send-success="updateOrder"
      :type="35"
    ></send-dialog>
    <edit-dialog
      v-model="editObj.showDialog"
      :order="editObj.selectOrder"
      :type="35"
      @edit-success="updateOrder"
    ></edit-dialog>
  </div>
</template>

<script>
import { getOrderDetail, closeOrder } from '@/api/order';
import { Toast, Dialog } from 'vant';
import * as orderTool from '@/views/order/orderTool';
import { formatDateTime } from '@/utils/index';
import mixinRefund from '@/views/order/mixin/refund';
import mixinSend from '@/views/order/mixin/send';
import mixinEdit from '@/views/order/mixin/edit';
export default {
  filters: {
    getOrderTradeStateStr: orderTool.getOrderTradeStateStr,
  },
  mixins: [mixinRefund, mixinSend, mixinEdit],
  data() {
    return {
      countdownT: null,
      loadSuccess: false,
      id: '',
      order: {},
      timeStr: '',
      countDownFlag: true,
      cellBaseList: [],
      cellOrderList: [],
      timeStamp: '',
      order_steps: {
        steps: [
          {
            text: '买家付款',
          },
          {
            text: '商家发货',
          },
          {
            text: '交易完成',
          },
        ],
        active: -1,
      },
      stateUrl: '',
      showPayDialog: false,
    };
  },
  created() {
    this.id = this.$route.params.id;
    this.requestData();
  },
  methods: {
    updateOrder: function(order) {
      console.log(order);
      let step_active;
      let stepStateUrl;
      switch (order.tradeState) {
        case 0:
          //待付款
          step_active = -1;
          stepStateUrl =
            'https://img.zai-art.com/zaiart_article/61f12e9a3a28e57d6475264532473c65.png';
          break;
        case 3:
          //"待发货"
          step_active = 0;
          stepStateUrl =
            'https://img.zai-art.com/zaiart_article/6c4298d53f1a552f02089a768372f1cf.png';
          break;
        case 6:
          // "待收货";
          step_active = 1;
          stepStateUrl =
            'https://img.zai-art.com/zaiart_article/4f23cb39c3d9dd2abcd4fc00d932602d.png';
          break;
        case 10:
          // "取消";
          stepStateUrl =
            'https://img.zai-art.com/zaiart_article/61f12e9a3a28e57d6475264532473c65.png';
          break;
        case 20:
          // "完成";
          step_active = 2;
          stepStateUrl =
            'https://img.zai-art.com/zaiart_article/43ec15d777da649e07e0fc9fcbdedb1a.png';
          break;
        case 30:
          step_active = -1;
          // "退款中";
          break;
        case 40:
          // "已退款";
          step_active = -1;
          stepStateUrl =
            'https://img.zai-art.com/zaiart_article/61f12e9a3a28e57d6475264532473c65.png';
          break;
        default:
          // "未知";
          step_active = -1;
          break;
      }
      if (order.tradeUserParam && order.tradeUserParam.userParam) {
        // userParam 为字符串
        order.tradeUserParam.userParam = JSON.parse(order.tradeUserParam.userParam).data;
      }
      // let defaultAddressType = order.onSite && order.onlySite ? 1 : 0
      // let addressType =
      //   order.addressType != null && order.addressType != undefined
      //     ? order.addressType
      //     : defaultAddressType

      this.loadSuccess = true;
      this.order = order;
      this.countDownFlag = order.tradeState == 0;
      let goodAmount = {
        label: '商品金额',
        value: order.goodAmount.toFixed(2),
        before: '¥',
      };
      let tradeAmount = {
        label: '优惠金额',
        value: order.tradeDiscount.toFixed(2),
        before: order.tradeDiscount > 0 ? '-¥' : '¥',
        hide: order.tradeDiscount <= 0,
      };
      if (order.goodOriginPrice) {
        goodAmount = {
          label: '商品金额',
          value: order.goodOriginPrice.toFixed(2),
          before: '¥',
        };
        tradeAmount = {
          label: '优惠金额',
          value: (order.goodOriginPrice - order.goodAmount + order.tradeDiscount).toFixed(2),
          before: order.goodOriginPrice - order.goodAmount + order.tradeDiscount > 0 ? '-¥' : '¥',
        };
      }
      this.cellBaseList = [
        goodAmount,
        tradeAmount,
        {
          label: '运费',
          value:
            order.freightBuyerPay && order.freightAmount == 0
              ? '运费到付'
              : order.freightAmount.toFixed(2),
          before: order.freightBuyerPay && order.freightAmount == 0 ? '' : '¥',
          hide: (!order.needAddress || order.onlySite) && order.freightAmount <= 0,
        },
        {
          label: '合计',
          value: order.payAmount.toFixed(2),
          className: 'price',
          isPrice: true,
          before: '¥',
        },
      ];
      this.cellOrderList = [
        {
          label: '订单编号',
          value: order.id,
        },
        {
          label: '创建时间',
          value: formatDateTime(order.createTime),
        },
        {
          label: '付款时间',
          value: formatDateTime(order.payTime),
        },
        {
          label: '发货时间',
          value: formatDateTime(order.shipTime),
        },
        {
          label: '完成时间',
          value: formatDateTime(order.completeTime),
        },
        {
          label: '订单备注',
          value: order.remark,
        },
        {
          label: '支付状态',
          value: orderTool.getOrderPayStateStr(order.payState),
          hide: order.payState != 110,
        },
      ];
      this.order_steps.active = step_active >= 0 ? step_active : -1;
      this.order_steps.stateUrl = stepStateUrl || '';
      if (order.tradeState == 0 || order.tradeState == 10) {
        let EndTime = this.order.autoCancelTime || [];
        let NowTime = this.timeStamp;
        let total_micro_second = EndTime - NowTime || '';
        this.countdown(this, false, total_micro_second);
      } else if (order.tradeState == 6) {
        this.timeStr =
          '（' + formatDateTime(this.order.getAutoComfirmReceiptTime) + '自动确认收货）';
      } else {
        this.timeStr = '';
      }
    },
    requestData: function() {
      Toast.loading({
        message: '加载中...',
        forbidClick: true,
      });
      getOrderDetail({
        id: this.id,
      })
        .then(response => {
          Toast.clear();
          this.timeStamp = response.timestamp;
          this.updateOrder(response.data);
        })
        .catch(response => {
          Toast.clear();
          Toast.fail({
            message: response.message,
          });
        });
    },

    clickCopy: function(e) {
      this.$copyText(text).then(
        e => {
          this.$toast.success('复制成功');
        },
        e => {
          this.$toast.fail('复制失败');
        },
      );
    },
    clickClose(e) {
      let self = this;
      Dialog.confirm({
        title: '操作提示',
        message: '确认要关闭订单么？',
      })
        .then(() => {
          closeOrder({
            id: item.id,
          }).then(res => {
            self.refreshList(res.data);
          });
        })
        .catch(() => {
          // on cancel
        });
    },
    countdown(context, needRequest, total_micro_second) {
      function dateformat(micro_second) {
        let second = Math.floor(micro_second / 1000);
        let day = Math.floor(second / 3600 / 24);
        let hr = Math.floor((second / 3600) % 24);
        let min = Math.floor((second / 60) % 60);
        let sec = Math.floor(second % 60);
        return (
          (day >= 0 ? day + '天' : '') +
          (hr >= 0 ? hr + '小时' : '') +
          (min >= 0 ? min + '分钟' : '') +
          (sec >= 0 ? sec + '秒' : '')
        );
      }
      if (!total_micro_second) {
        let EndTime = context.data.order.autoCancelTime || [];
        let NowTime = timeStamp ? timeStamp : new Date().getTime();
        total_micro_second = EndTime - NowTime || [];
      }
      context.timeStr = '剩余支付时间 ' + dateformat(total_micro_second);
      if (total_micro_second <= 0 || !dateformat(total_micro_second)) {
        context.timeStr = '';
        clearTimeout(this.countdownT);
        if (needRequest) context.requestData();
      }
      console.log(this.countDownFlag);
      if (total_micro_second && total_micro_second > 0 && context.countDownFlag) {
        this.countdownT = setTimeout(() => {
          total_micro_second -= 1000;
          this.countdown(context, true, total_micro_second);
        }, 1000);
      }
      //手动清零 防止最后一次计时显示
      if (!context.countDownFlag) {
        context.timeStr = '';
      }
    },
  },
  destroyed() {
    this.countDownFlag = false;
  },
};
</script>
<style scoped src="../order-detail.css"></style>
<style scoped></style>
